import web_skills from '../../data/web_skills.json'
import mobile_skills from '../../data/mobile_skills.json'
import other_skills from '../../data/other_skills.json'
import { useEffect, useState } from 'react';

export default function MySkills(){
    const [webSkills, setWebSkills] = useState([]);
    const [mobileSkills, setMobileSkills] = useState([]);
    const [otherSkills, setOtherSkills] = useState([]);
    useEffect(() =>{
        setWebSkills([...web_skills]);
        setMobileSkills([...mobile_skills]);
        setOtherSkills([...other_skills]);
    },[]);
    return (
        <section id="skills" className='skills--section bg-white'>
            <div>
                <h2 className='section-heading'>Skills</h2>
                <div>
                    <div className="header-bar"></div>
                </div>
            </div>
            <div className='container skills-block'>
                <div className='columns'>
                    <div className='column'>
                        <div className='column-icon'><img src='./img/web.svg' alt="Web development icon" /></div>
                        <h3 className='skill-title'>Web Application Development</h3>
                        <p className='skill-desc'>I like to experience the evolving web technologies, and enjoy bringing the beautified project ideas to the browser</p>
                        <ul className='row no-bullets'>
                            {webSkills.map((skill,i) => {
                                return <li key={skill.id} className='skillName col'><span>{skill.title}</span></li>
                            })}
                        </ul>
                    </div>
                    <hr/>
                    <div className='column'>
                        <div className='column-icon'><img src='./img/mobile.svg' alt="Mobile development icon" /></div>
                        <h3 className='skill-title'>Mobile App Development</h3>
                        <p className='skill-desc'>I value appealing user interfaces, implement features, integrate APIs, and ensure app's functionality and performance meet the requirements</p>
                        <ul className='row no-bullets'>
                            {mobileSkills.map((skill,i) => {
                                return <li key={skill.id} className='skillName col'><span>{skill.title}</span></li>
                            })}
                        </ul>
                    </div>
                    <hr/>
                    <div className='column'>
                        <div className='column-icon'><img src='./img/others.svg' alt="Other skills icon" /></div>
                        <h3 className='skill-title'>Miscellaneous</h3>
                        <p className='skill-desc'>It is interesting to work with database and cloud concepts and I always explore to meet new challenges</p>
                        <ul className='row no-bullets'>
                            {otherSkills.map((skill,i) => {
                                return <li key={skill.id} className='skillName col'><span>{skill.title}</span></li>
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}